import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function firstNameLastNameFirmNameValidator(fields: string[]): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const hasValue = fields.some(field => {
      const control = formGroup.get(field);
      return control && control.value && control.value.toString().trim() !== '';
    });

    return hasValue ? null : { atLeastOneRequired: true };
  };
}